const capitalize = (s) => {
	return s.replace(
		/(^[a-z-zñáéíóú]| [a-z-zñáéíóú])/g,
		function (match, letter) {
			return letter.toUpperCase();
		}
	);
};

export default capitalize